module.exports = __webpack_public_path__ + "img/achievement_23.ec3ec665.png";